<script setup lang="ts">
import { SearchIcon } from '@lucide/vue'
import { DSKbd } from '@ds'

type Props = {
  placeholder?: string
  shortcut?: string
  isShrunk?: boolean
}

const { placeholder = 'Search', shortcut, isShrunk } = defineProps<Props>()
</script>

<template>
  <button
    type="button"
    class="flex items-center rounded-ds-md text-muted-foreground cursor-pointer"
    :class="
      isShrunk ?
        'shrink-0 justify-center size-10 hover:bg-background hover:text-foreground transition-colors duration-ds-fast ease-ds-standard' :
        'gap-2.5 w-85 h-9.5 px-3 border border-border bg-card'
    "
  >
    <SearchIcon
      class="shrink-0"
      :class="isShrunk ? 'size-5' : 'size-4.5'"
      aria-hidden="true"
    />
    <span
      v-if="!isShrunk"
      class="flex-1 text-left text-sm font-medium truncate"
    >{{ placeholder }}</span>
    <DSKbd
      v-if="shortcut && !isShrunk"
      class="shrink-0"
    >
      {{ shortcut }}
    </DSKbd>
  </button>
</template>
